module.exports = __webpack_public_path__ + "img/base_nature_plage.91f01e40.svg";